import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function InvestorRelationViewer({ pdfPath, onClose }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth > 1000 ? 1000 : window.innerWidth * 0.9);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) setPageNumber((prev) => prev - 1);
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) setPageNumber((prev) => prev + 1);
  };

  // const goToPage = (pageIndex) => {
  //   setPageNumber(pageIndex + 1);
  // };

  return (
    <div
      className="pdf-viewer-modal"
      id="pdf-viewer-content"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px",
        boxSizing: "border-box",
      }}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          fontSize: "1.5rem",
          cursor: "pointer",
          color: "white",
        }}
      >
        &times;
      </button>

      <Document
        file={pdfPath}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={console.error}
      >
        {width && (
          <Page
            pageNumber={pageNumber}
            width={width}
            renderTextLayer={true}
            renderAnnotationLayer={true}
          />
        )}
      </Document>

      {numPages && (
        <div
          style={{
            marginTop: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            onClick={goToPrevPage}
            disabled={pageNumber <= 1}
            style={{ marginRight: "10px" }}
          >
            Previous
          </button>
          <span style={{ color: "white" }}>
            Page {pageNumber} of {numPages}
          </span>
          <button
            onClick={goToNextPage}
            disabled={pageNumber >= numPages}
            style={{ marginLeft: "10px" }}
          >
            Next
          </button>
        </div>
      )}

      {/* Download Button */}
      <a
        href={pdfPath}
        download
        style={{
          backgroundColor: "blue",
          width:"50%",
          color: "white",
          padding: "18px 16px",
          marginTop:'20px',
          borderRadius: "5px",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: "500",
          display: "inline-block",
        }}
      >
        Download PDF
      </a>

      {numPages && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {/* {Array.from(new Array(numPages), (el, index) => (
            <span
              key={`page-dot-${index}`}
              onClick={() => goToPage(index)}
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: pageNumber === index + 1 ? "#00cc66" : "#ccc",
                borderRadius: "50%",
                display: "inline-block",
                margin: "0 5px",
                cursor: "pointer",
              }}
            ></span>
          ))} */}
        </div>
      )}
    </div>
  );
}

export default InvestorRelationViewer;
